/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([], function () {

  return {
    tab        : 9,
    enter      : 13,
    esc        : 27,

    "delete"   : 46,

    space      : 32,
    pageup     : 33,
    pagedown   : 34,
    end        : 35,
    home       : 36,

    left       : 37,
    up         : 38,
    right      : 39,
    down       : 40,

    f2         : 113,
    f10        : 121,

    menu       : 93
  };

});
